import React from 'react'
import PropTypes from 'prop-types'
import env from './../../../../environments/environment'
import placeholder_picture from './../../../../assets/images/user_placeholder.png'

/**
 * ImagePreview component - Displays the current headshot or placeholder
 * @param {Object} props - Component props
 * @param {string} props.headshotUrl - The headshot URL from storage
 * @param {string} props.className - Additional CSS classes
 * @param {Object} props.style - Additional inline styles
 * @param {React.ReactNode} props.badge - Optional overlay pinned to the image corner
 */
const ImagePreview = ({ headshotUrl, className = '', style = {}, badge = null }) => {
  const defaultStyle = {
    maxHeight: '250px',
    ...style,
  }

  if (headshotUrl) {
    const imageUrl = `https://firebasestorage.googleapis.com/v0/b/${
      env.integrations.firebase.config.storageBucket
    }/o/${encodeURIComponent(headshotUrl)}?alt=media`

    return (
      <div className={`image-preview ${className}`}>
        <div className='image-preview__frame'>
          <img src={imageUrl} alt='Current headshot' style={defaultStyle} className='img-fluid' />
          {badge}
        </div>
      </div>
    )
  }

  return (
    <div className={`image-preview ${className}`}>
      <img
        src={placeholder_picture}
        alt='Placeholder headshot'
        style={defaultStyle}
        className='img-fluid d-block headshot-ratio'
      />
    </div>
  )
}

ImagePreview.propTypes = {
  headshotUrl: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  badge: PropTypes.node,
}

export default ImagePreview
